// extracted by mini-css-extract-plugin
module.exports = {"previewSectionTitle":"PreviewSectionTitle_previewSectionTitle_3yMIP"};